<div class='row'>
  @if (occupation?.occupationType; as type) {
    <div class='col-md-4'>
      <app-label label='Rodzaj:'>
        {{ type | occupationType: roadOccupationTypes() }}
      </app-label>
    </div>
  }
  @if (occupation?.surfaceViolation; as surfaceViolation) {
    <div class='col-md-4'>
      <app-label label='Rodzaj:'>
        {{ surfaceViolation }}
      </app-label>
    </div>
  }
  @if (occupation?.workPurpose; as workPurpose) {
    <div class='col-12'>
      <app-label label='Cel prowadzenia robót:'>
        {{ workPurpose }}
      </app-label>
    </div>
  }
  @if (occupation?.purpose; as purpose) {
    <div class='col-md-4'>
      <app-label label='Cel zajęcia:'>
        {{ purpose }}
      </app-label>
    </div>
  }
</div>
<div class='row'>
  @if (!!occupation?.locationDecisionNumber) {
    <div class='col-md-6'>
      <app-label label='Numer decyzji lokalizacyjnej:'>
        {{ occupation?.locationDecisionNumber }}
      </app-label>
    </div>
  }
  @if (!!occupation?.locationDecisionDate) {
    <div class='col-md-6'>
      <app-label label='Data wydania decyzji lokalizacyjnej:'>
        {{ occupation?.locationDecisionDate | date }}
      </app-label>
    </div>
  }
  @if (!!occupation?.agreementNumber) {
    <div class='col-md-6'>
      <app-label label='Numer uzgodnienia::'>
        {{ occupation?.agreementNumber }}
      </app-label>
    </div>
  }
  @if (!!occupation?.agreementDate) {
    <div class='col-md-6'>
      <app-label label='Data wydania uzgodnienia:'>
        {{ occupation?.agreementDate | date }}
      </app-label>
    </div>
  }
</div>
<br>
<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol>
      @for (stage of occupation?.stages; track $index) {
        <li>
          <div class='row'>
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage.endDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Ilość dni:'>
                {{ stage.dayQuantity }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Geometria:'>
                -
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Miejscowość:">
                {{ stage.city }}
              </app-label>
            </div>
            @if (stage.roadNumber; as roadNumber) {
              <div class="col-md-4">
                <app-label label="Numer drogi:">
                  {{ roadNumber }}
                </app-label>
              </div>
            }
            @if (stage.roadName; as roadName) {
              <div class="col-md-4">
                <app-label label="Nazwa drogi:">
                  {{ roadName }}
                </app-label>
              </div>
            }
            @if (stage.street; as street) {
              <div class="col-md-4">
                <app-label label="Ulica:">
                  {{ street }}
                </app-label>
              </div>
            }
          </div>
          <br>
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>
                  Działki
                </strong>
              </p>
              <app-parcels-preview [parcels]="stage.parcels">
              </app-parcels-preview>
              <br>
            </div>
          </div>
          <app-road-occupation-stage-table [stage]='stage'>
          </app-road-occupation-stage-table>
        </li>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>

